import { cloneDeep } from 'lodash';
import React, { useState, useEffect } from 'react';

function SelectCount({ equipmentToTrail, slots, hour, onChange, value, pricing }) {
  const [loading, setLoading] = useState(false);
  const [maxCount, setMaxCount] = useState(equipmentToTrail.equipment.count);

  useEffect(() => {
    if (!slots.length) return;
  
    // check if current hour is still available
    if (hour) {
      const slot = slots.find(x => x.startTimeHuman === hour);
      const etr = slot.equipmentsToTrail.find(x => x.id === equipmentToTrail.id);
      setMaxCount(etr.available > 0 ? etr.available : 0);
    } else {
      const maxDuringThisDay = cloneDeep(slots)
        .map(x => x.equipmentsToTrail.find(x => x.id === equipmentToTrail.id))
        .map(x => x.available)
        .sort((a, b) => b - a)[0]
      setMaxCount(maxDuringThisDay)
    }
  }, [slots, hour]);

  // useEffect(() => {
  //   setLoading(true);
  //   setTimeout(() => setLoading(false), 500);
  // }, [hour]);

  return (
    <div className="form-group mb-3">
      <label className="form-label">
        {equipmentToTrail.equipment.title}
        {/* <template v-if="item.original_price && item.original_price != item.price && item.price < item.original_price">
          (<del>{'item.original_price'}zł</del> <span className="text-success">{'item.price'}zł/szt</span>)
        </template> */}
        &nbsp; &nbsp;
        {pricing 
          ? <span className="text-muted">{parseFloat(pricing.hasNewPrice ? pricing.newPrice.price : pricing.price)} zł</span>
          : <span className="text-muted">{parseFloat(equipmentToTrail.price)} zł</span>
        }
      </label>

      <div className="input-desc">{equipmentToTrail.equipment.description}</div>
      <div style={{ position: 'relative' }}>
        <select 
          className="form-control" 
          value={value} 
          onChange={e => onChange(equipmentToTrail.id, equipmentToTrail.equipment.id, +e.target.value)}
          disabled={maxCount === 0}
        >
          {maxCount > 0 && Array(maxCount + 1).fill('').map((x, i) => (
            <option value={i} key={i}>{i}</option>
          ))}
          {maxCount === 0 && <option value={0}>Brak wolnych pozycji</option>}
        </select>

        <span 
          className="spinner-border spinner-border-sm" 
          role="status" 
          aria-hidden="true" 
          style={{ position: 'absolute', top: 8, right: 20, transition: 'all 0.2s linear', opacity: loading ? 1 : 0 }}></span>
      </div>
    </div>
  );
}

export default SelectCount;